import PaginationBar from './containers/PaginationContainer.js';

export default PaginationBar;
